import { NgModule, ModuleWithProviders } from '@angular/core';

import { FroalaViewDirective } from './view.directive';


export class FroalaViewModule {
  public static forRoot(): ModuleWithProviders {
    return {ngModule: FroalaViewModule, providers: []};
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FroalaViewDirective],
  exports: [FroalaViewDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
